import { Field } from "@base-ui/react/field";
import { Radio } from "@base-ui/react/radio";
import { RadioGroup } from "@base-ui/react/radio-group";
import { Controller, useFormContext } from "react-hook-form";
import type { FormField } from "@/types/academy";

const FormYesNo = ({ block, name }: { block: FormField; name: string }) => {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      defaultValue={block.prefillValue || ""}
      name={name}
      render={({ field, fieldState }) => {
        return (
          <Field.Root
            className="flex flex-col items-start gap-1"
            dirty={fieldState.isDirty}
            invalid={fieldState.invalid}
            name={block.id}
            touched={fieldState.isTouched}
          >
            <div className="text-sm font-bold text-gray-900" id={block.id}>
              {block.label || "Evet/Hayır"}
            </div>
            <RadioGroup
              aria-labelledby={block.id}
              className="flex flex-row items-start gap-1 text-gray-900"
              onBlur={field.onBlur}
              onValueChange={field.onChange}
              ref={field.ref}
              value={field.value}
            >
              {block.optionItems?.map((option) => {
                return (
                  <label
                    className="flex items-center gap-2 font-normal"
                    htmlFor={option.id}
                    id={option.id}
                    key={option.id}
                  >
                    <Radio.Root
                      className="flex size-5 items-center justify-center rounded-full focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-border-800 data-checked:bg-brand-blue-600 data-unchecked:border data-unchecked:cursor-pointer data-unchecked:border-gray-300"
                      value={option.id}
                    >
                      <Radio.Indicator className="flex before:size-2 before:rounded-full before:bg-gray-50 data-unchecked:hidden" />
                    </Radio.Root>
                    {option.label}
                  </label>
                );
              })}
            </RadioGroup>
            <Field.Error
              className="text-sm text-red-600 font-medium"
              match={!!fieldState.error}
            >
              {block.helperText || "Bu alan zorunludur"}
            </Field.Error>

            <Field.Description className="text-sm text-gray-600" />
          </Field.Root>
        );
      }}
      rules={{
        required: block.isRequired,
      }}
    />
  );
};

export default FormYesNo;
